import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';

import { PaymentIcon } from './PaymentIcon';
import { useCheckPagePayment } from './useCheckPagePayment';

const sectionId = 'ChangeDueModal';

interface ChangeDueModalProps {
  control: ReturnType<typeof useCheckPagePayment>['modal']['changeDue'];
}

const ChangeDueModal: FC<ChangeDueModalProps> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Modal
      data-testid={sectionId}
      open={control.isOpen}
      onBackDropClick={control.close}
      loading={control.loading}
    >
      <ModalHeader>
        <ModalTitle copy={t('payment.labels.changeDue')} />
      </ModalHeader>
      <ModalContent flex={{ alignItems: 'center', justifyContent: 'center', gap: 'xs' }}>
        <Copy variant="h4" value={t('labels.util.currency', { value: control.changeDue })} align="center" />
        <Flex horizontal alignItems="center" gap="xs">
          <PaymentIcon paymentType="Cash" size="sm" />
          <Copy value={t('payment.labels.amountPaidVsTotal', { paid: control.check?.balance.paid ?? 0, total: control.check?.balance.total ?? 0 })} align="center" />
        </Flex>
      </ModalContent>
      <ModalActions>
        <ModalAction label={t('labels.void')} variant="outlined" onClick={control.onVoidClick} />
        <ModalAction label={t('labels.noReceipt')} color="secondary" onClick={control.close} />
        <ModalAction label={t('labels.receipt')} color="primary" onClick={control.onReceiptClick} />
      </ModalActions>
    </Modal>
  );
};

export { ChangeDueModal };
